import React from "react";
import { Drawer } from "@mui/material";
import DrawerHeader from "../../shared/helpers/DrawerHeader.js";
import DrawerFooterContainerSmall from "../../shared/helpers/DrawerFooterContainerSmall.js";
import ButtonFilled from "../../shared/helpers/ButtonFilled.js";
import ButtonFilledCancel from "../../shared/helpers/ButtonFilledCancel.js";
import ModalInfoCard from "../../shared/helpers/ModalInfoCard.js";
import ModalUserStatusCard from "../../shared/helpers/ModalUserStatusCard.js";
import {
  formatDateReadable,
  formatTimestampDateReadable,
} from "../../utilities/helpers.js";
import { get_t_str } from "../../../../../helpers/helpers.js";
import {
  CalendarToday,
  DescriptionOutlined,
  ChatBubbleOutline,
  Send,
  Edit,
  AccessTime,
  LocalOfferOutlined
} from '@mui/icons-material';

const TimeOffRequestDrawer = (props) => {
  const [managerNote, setManagerNote] = React.useState("");

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    props.setDrawerOpen(open);
    if (!open) {
      setManagerNote("");
    }
  };

  const handleSubmit = (response) => {
    if (props.respond_to_time_off_request && props.requestInfo) {
      props.respond_to_time_off_request(props.requestInfo.uuid, response, managerNote);
      props.setDrawerOpen(false);
      setManagerNote("");
    }
  };

  return (
    <Drawer
      anchor="right"
      open={props.isDrawerOpen}
      onClose={toggleDrawer(false)}
      sx={props.sx || {}}
    >
      <div className="w-[450px] h-screen bg-white relative">
        <div className="max-h-screen overflow-auto">
          <DrawerHeader
            title="Time Off Request"
            onClose={toggleDrawer(false)}
          />
          <div className="px-6">
            {/* User Status Section */}
            <div className="mb-6">
              <ModalUserStatusCard
                name={`${props.requestInfo.firstName} ${props.requestInfo.lastName}`}
                status="pending"
              />
            </div>
            {/* Info Cards */}
            <div className="w-full">
              <div className="mb-4">
                <ModalInfoCard
                  icon={DescriptionOutlined}
                  title="Title"
                  value={props.requestInfo.title}
                />
              </div>

              {props.requestInfo.time_off_type && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={LocalOfferOutlined}
                    title="Type"
                    value={
                      props.requestInfo.time_off_type === 'UNPAID' ? 'Unpaid' :
                      props.requestInfo.time_off_type === 'PTO' ? 'Paid Time Off (PTO)' :
                      props.requestInfo.time_off_type === 'SICK' ? 'Sick Leave' :
                      'Not specified'
                    }
                  />
                </div>
              )}

              <div className="mb-4">
                <ModalInfoCard
                  icon={CalendarToday}
                  title="Time Off Period"
                  value={`${formatDateReadable(props.requestInfo.startDate)} ${props.requestInfo.endDate ? `- ${formatDateReadable(props.requestInfo.endDate)}` : ''}`}
                />
              </div>

              {props.requestInfo.startTime && props.requestInfo.endTime && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={AccessTime}
                    title="Time Off Partial Day"
                    value={`${get_t_str(props.requestInfo.startTime)} - ${get_t_str(props.requestInfo.endTime)}`}
                  />
                </div>
              )}

              {props.requestInfo.note && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={ChatBubbleOutline}
                    title="Employee Note"
                    value={props.requestInfo.note}
                  />
                </div>
              )}

              <div className="mb-4">
                <ModalInfoCard
                  icon={Send}
                  title="Date Submitted"
                  value={formatTimestampDateReadable(props.requestInfo.dateSubmitted, props.storeTimezone)}
                />
              </div>

              {/* Manager Note Input Section */}
              <div className="mb-4">
                <div className="bg-slate-50 border border-slate-200 rounded-xl p-4">
                  <div className="flex flex-row items-center space-x-2 mb-3 text-gray-700">
                    <Edit style={{ fontSize: "18px" }} />
                    <span className="text-slate-700 font-medium text-sm">
                      Response Note
                    </span>
                  </div>
                  <textarea
                    placeholder="Add a note (optional)"
                    className="w-full bg-white border border-slate-300 text-slate-900 px-4 py-3 rounded-xl text-sm resize-none focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
                    rows={3}
                    value={managerNote}
                    onChange={(e) => setManagerNote(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="h-[200px]"></div>
          </div>
        </div>
        <DrawerFooterContainerSmall>
          <div className="w-full flex flex-row items-center">
            <div className="w-1/2 pr-2">
              <ButtonFilledCancel
                text="Deny"
                onClick={() => handleSubmit("REJECTED")}
              />
            </div>
            <div className="w-1/2 pl-2">
              <ButtonFilled
                text="Approve"
                onClick={() => handleSubmit("APPROVED")}
              />
            </div>
          </div>
        </DrawerFooterContainerSmall>
      </div>
    </Drawer>
  );
};

export default TimeOffRequestDrawer;
